// Business Stage taxonomy for prospect intake.
// UX-only: business leaders see the label; codes stay internal for AI + benchmarks.
// Reuses the existing `organisation_size` schema field — no DB redesign.
export const BUSINESS_STAGES = [
  { code: "SOLO", label: "Independent Consultant / Solo Business" },
  { code: "SMALL", label: "Small Business" },
  { code: "GROWTH", label: "Growing Business" },
  { code: "MID", label: "Mid-Market Organisation" },
  { code: "ENTERPRISE", label: "Large Enterprise" },
];

export const STAGE_LABEL = Object.fromEntries(
  BUSINESS_STAGES.map((s) => [s.code, s.label])
);
export const stageLabel = (code) => STAGE_LABEL[code] || code || "";
